import { isZodArray, isZodDiscriminatedUnion, isZodIntersection, isZodMap, isZodObject, isZodRecord, isZodSet, isZodUnion } from "./zodTypeGuards.js";
const ARRAY_ITEM_WILDCARD = '0';
const MAP_WILDCARD = '__key__';
const getSchemaPathRequirementMap = (schema)=>{
    const pathRequirementMap = {};
    const checkPathInSchema = (schema, path)=>{
        const [strippedSchema, strippedLayers] = stripZodWrappers(schema);
        const isCurrentSubpathRequired = !hasOptionalWrapper(strippedLayers);
        if ('' !== path && !(path in pathRequirementMap)) pathRequirementMap[path] = isCurrentSubpathRequired;
        if (isZodObject(strippedSchema)) {
            const nestedPaths = Object.keys(strippedSchema.shape);
            for (const nestedPath of nestedPaths)checkPathInSchema(strippedSchema.shape[nestedPath], joinPaths(path, nestedPath));
        }
        if (isZodArray(strippedSchema)) checkPathInSchema(strippedSchema.element, joinPaths(path, ARRAY_ITEM_WILDCARD));
        if (isZodSet(strippedSchema)) checkPathInSchema(strippedSchema._def.valueType, joinPaths(path, ARRAY_ITEM_WILDCARD));
        if (isZodUnion(strippedSchema)) {
            let isUnionRequired = isCurrentSubpathRequired;
            for (const option of strippedSchema.options){
                const isUnionPartRequired = checkPathInSchema(option, path);
                if (!isUnionPartRequired) isUnionRequired = false;
            }
            pathRequirementMap[path] = isUnionRequired;
            return isUnionRequired;
        }
        if (isZodDiscriminatedUnion(strippedSchema)) for (const option of strippedSchema.options)checkPathInSchema(option, path);
        if (isZodIntersection(strippedSchema)) {
            const isLeftPartRequired = checkPathInSchema(strippedSchema._def.left, path);
            const isRightPartRequired = checkPathInSchema(strippedSchema._def.right, path);
            const isIntersectionOptional = !isCurrentSubpathRequired || !isRightPartRequired && !isLeftPartRequired;
            pathRequirementMap[path] = !isIntersectionOptional;
            return !isIntersectionOptional;
        }
        if (isZodMap(strippedSchema) || isZodRecord(strippedSchema)) checkPathInSchema(strippedSchema._def.valueType, joinPaths(path, MAP_WILDCARD));
        return isCurrentSubpathRequired;
    };
    checkPathInSchema(schema, '');
    return pathRequirementMap;
};
const hasZodWrappers = (schema)=>Boolean(schema.sourceType || schema._def?.innerType);
const stripZodWrappers = (schema, _strippedTypes = [])=>{
    const strippedTypes = [
        ..._strippedTypes
    ];
    let strippedSchema = schema;
    if (hasZodWrappers(schema)) {
        strippedTypes.push(schema._def?.typeName);
        strippedSchema = schema.sourceType?.() ?? schema._def?.innerType ?? schema;
    }
    if (hasZodWrappers(strippedSchema)) return stripZodWrappers(strippedSchema, strippedTypes);
    return [
        strippedSchema,
        strippedTypes
    ];
};
const hasOptionalWrapper = (wrappers)=>wrappers.includes('ZodOptional') || wrappers.includes('ZodNullable');
const joinPaths = (rootPath, path)=>[
        rootPath,
        path
    ].filter((path)=>'' !== path).join('.');
export { ARRAY_ITEM_WILDCARD, MAP_WILDCARD, getSchemaPathRequirementMap, joinPaths };
